import logoMark from '@/assets/logo_w.png'
import logoWordmark from '@/assets/logo_xs.png'

export function BrandLogo({ compact = false, className }: { compact?: boolean; className?: string }) {
  return <img className={className} src={compact ? logoMark : logoWordmark} alt="Witemedia" width={compact ? 56 : 351} height={compact ? 56 : 69} />
}
